/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    MenuItem,
    MenuItemFromJSON,
    MenuItemToJSON,
    MenuItemDataFrame,
    MenuItemDataFrameFromJSON,
    MenuItemDataFrameToJSON,
} from '../models';

export interface ApiMenuItemsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiMenuItemsIdDeleteRequest {
    id: number;
}

export interface ApiMenuItemsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiMenuItemsPostRequest {
    relations?: string;
    deleted?: boolean;
    menuItem?: MenuItem;
}

/**
 * no description
 */
export class MenuItemApi extends runtime.BaseAPI {

    /**
     * Get list of MenuItem
     */
    async apiMenuItemsGetRaw(requestParameters: ApiMenuItemsGetRequest): Promise<runtime.ApiResponse<MenuItemDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/menuItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuItemDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of MenuItem
     */
    async apiMenuItemsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<MenuItemDataFrame> {
        const response = await this.apiMenuItemsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of MenuItem
     */
    async apiMenuItemsIdDeleteRaw(requestParameters: ApiMenuItemsIdDeleteRequest): Promise<runtime.ApiResponse<MenuItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiMenuItemsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/menuItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuItemFromJSON(jsonValue));
    }

    /**
     * Remove entity of MenuItem
     */
    async apiMenuItemsIdDelete(id: number): Promise<MenuItem> {
        const response = await this.apiMenuItemsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of MenuItem
     */
    async apiMenuItemsIdGetRaw(requestParameters: ApiMenuItemsIdGetRequest): Promise<runtime.ApiResponse<MenuItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiMenuItemsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/menuItems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuItemFromJSON(jsonValue));
    }

    /**
     * Get entity of MenuItem
     */
    async apiMenuItemsIdGet(id: number, relations?: string, deleted?: boolean): Promise<MenuItem> {
        const response = await this.apiMenuItemsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of MenuItem (if id defined)
     */
    async apiMenuItemsPostRaw(requestParameters: ApiMenuItemsPostRequest): Promise<runtime.ApiResponse<MenuItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/menuItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MenuItemToJSON(requestParameters.menuItem),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MenuItemFromJSON(jsonValue));
    }

    /**
     * Create or update entity of MenuItem (if id defined)
     */
    async apiMenuItemsPost(relations?: string, deleted?: boolean, menuItem?: MenuItem): Promise<MenuItem> {
        const response = await this.apiMenuItemsPostRaw({ relations: relations, deleted: deleted, menuItem: menuItem });
        return await response.value();
    }

}
